import { useMessageSource } from "react-message-source";
import * as Yup from "yup";
import useEmailValidator from "../../shared/components/email/validator";
import usePasswordValidator from "../../shared/components/formik/text-input/password/validator";
import { useTextInputValidator } from "../../shared/components/formik/text-input/validator";
import useGenderValidator from "../../shared/components/gender/validator";
import usePhoneNumberValidator from "../../shared/components/phone/validator";

export default function useAccountFormValidationSchema(isUpdateMode: boolean) {
  const { getMessage } = useMessageSource();

  const validateAcceptance = Yup.boolean().oneOf(
    [true],
    getMessage("Validation.message-mustAcceptTermsAndConditions"),
  );

  const genderValidator = useGenderValidator();
  const textInputValidator = useTextInputValidator();
  const phoneNumberValidator = usePhoneNumberValidator();
  const emailValidator = useEmailValidator();
  const passwordValidator = usePasswordValidator();

  const adminValidationSchema = Yup.object().shape({
    gender: genderValidator,
    firstName: textInputValidator,
    lastName: textInputValidator,
    mobile: phoneNumberValidator,
    emailBusiness: emailValidator,
  });

  if (isUpdateMode) {
    return Yup.object().shape({
      admin: adminValidationSchema,
    });
  }

  return Yup.object().shape({
    admin: adminValidationSchema,
    password: passwordValidator,
    acceptTermsAndConditions: validateAcceptance,
  });
}
